// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","614":"02660b7e","912":"6b5306e8"}[chunkId] + ".chunk.css";
};